export function decompressRLE2(data, offset, length) {
  throw 'Decompress Type RLE not implemented';
}